import type { LicenseExpirationReportResponse } from '../types'

const CSV_HEADERS = [
  'Organisation',
  'License Key',
  'Tier',
  'Valid Until',
  'Days Until Expiry',
  'Status',
  'Seats Used',
  'Seats Total',
  'Invoice',
  'User Email',
  'User Name',
]

function escapeCsvCell(cell: string): string {
  return `"${cell.replaceAll('"', '""')}"`
}

function buildLicenseBaseRow(
  orgName: string,
  license: LicenseExpirationReportResponse['organisations'][number]['licenses'][number]
): string[] {
  return [
    orgName,
    license.licenseKey,
    license.accessTier ?? '',
    license.validUntil ?? 'Perpetual',
    license.daysUntilExpiry?.toString() ?? '',
    license.expiryStatus,
    license.seatsUsed.toString(),
    license.seatsTotal.toString(),
    license.sourceInvoice ?? '',
  ]
}

function collectLicenseRows(
  orgName: string,
  license: LicenseExpirationReportResponse['organisations'][number]['licenses'][number]
): string[][] {
  const base = buildLicenseBaseRow(orgName, license)
  if (license.seats.length === 0) {
    return [[...base, '', '']]
  }
  return license.seats.map((seat) => [...base, seat.assignedEmail, seat.userName ?? ''])
}

export function buildCsvRows(report: LicenseExpirationReportResponse): string[][] {
  const rows: string[][] = [CSV_HEADERS]
  for (const org of report.organisations) {
    for (const license of org.licenses) {
      rows.push(...collectLicenseRows(org.name, license))
    }
  }
  return rows
}

export function rowsToCsvString(rows: string[][]): string {
  return rows.map((row) => row.map((cell) => escapeCsvCell(cell)).join(',')).join('\n')
}

export function triggerCsvDownload(csv: string, filename: string): void {
  const blob = new Blob([csv], { type: 'text/csv' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.click()
  URL.revokeObjectURL(url)
}
